import React, { Component } from 'react';
import { withRouter } from '../../../services/withRoute';
import ProjectTable from '../../components/projectTable';
import EquipmentListTableRow from '../../components/equipmentListTableRow';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import { ReactComponent as PendingIcon } from '../../../assets/svg/pending.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import { ReactComponent as SearchIcon } from '../../../assets/svg/search.svg';
import _, { times } from 'lodash';
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';
import { gql, throwServerError } from '@apollo/client';
import EquipmentsSummary from './EquipmentsSummary';
import DataTableCompact from '../../components/DataTableCompact';
const getEquipmentList = gql`
	query EquipmentList($filters: EquipmentListFiltersInput, $branchIds: [String]) {
		equipmentList(filters: $filters) {
			data {
				id
				qrCode
				type
				model
				description
				manufacturer
				manufacturerId
				status
				lastUsedBy {
					tenantId
					workspaceId
					projectId
					projectName
					projectSlNo
					eventId
					eventName
					eventSlNo
					userId
					userName
					usedAt
				}
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			hasPrevPage
			prevPage
			nextPage
		}
		equipmentSummary(branchIds: $branchIds) {
			type
			typeCount
			models {
				model
				count
				status
			}
		}
	}
`;
const getEquipmentSummary = gql`
	query EquipmentSummary {
		equipmentSummary {
			type
			typeCount
			models {
				model
				count
				status
			}
		}
	}
`;
const getOnlyEquipmentList = gql`
	query EquipmentList($filters: EquipmentListFiltersInput) {
		equipmentList(filters: $filters) {
			data {
				id
				qrCode
				type
				model
				description
				manufacturer
				manufacturerId
				status
				lastUsedBy {
					tenantId
					workspaceId
					projectId
					projectName
					projectSlNo
					eventId
					eventName
					eventSlNo
					userId
					userName
					usedAt
				}
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			hasPrevPage
			prevPage
			nextPage
		}
	}
`;

const getProjects = gql`
	query VendorsProjects($workspaceIds: [String!], $filters: projectsListFiltersInput) {
		vendorsProjects(workspaceIds: $workspaceIds, filters: $filters) {
			data {
				id
				title
			}
			totalDocs
		}
	}
`;

const getBranchList = gql`
	query BranchesList {
		branchesList {
			branchId
		}
	}
`;

const getVendorUsers = gql`
	query VendorUsers {
		vendorUsers {
			id
			firstName
			lastName
			phoneNumber
			displayName
		}
	}
`;

const getVendorInfo = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			isSuperHuemn
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
		}
	}
`;

class Expenses extends ProjectsGraphQlController {
	constructor() {
		super();
		this.state = {
			isLoading: true,
			limit: 30,
			page: 1,
			searchQuery: '',
			sortBy: '',
			sortType: 0,
			currentViewPage: 1,
			totalPages: 1,
			equipmentList: {},
			equipmentSummary: [],
			ownerIdActiveFilter: 'createdAt',
			tenantUsersList: {},
			assignedToFilters: {},
			searchType: 'qrCode',
			columns: [
				{ title: 'QR Code' },
				{ title: 'Model' },
				{ title: 'Type' },
				{ title: 'Status' },
				{ title: 'Event' },
				{ title: 'Assigned To' },
			],
			workspacesFilters: [],
			typesFilters: [
				{ key: 'batteryCharger', name: 'Battery Charger' },
				{ key: 'camera', name: 'Camera' },
				{ key: 'battery', name: 'Battery' },
				{ key: 'lens', name: 'Lens' },
				{ key: 'ledLightStick', name: 'Led Light Stick' },
				{ key: 'bowensMount', name: 'Bowens Mount' },
				{ key: 'flashUmbrellaClamp', name: 'Flash Umbrella Clamp' },
				{ key: 'ndFilter', name: 'ND Filter' },
				{ key: 'chargerCable', name: 'Charger Cable' },
				{ key: 'gimbleBattery', name: 'Gimble Battery' },
				{ key: 'bag', name: 'Bag' },
				{ key: 'cameraMicBag', name: 'Camera Mic bag' },
				{ key: 'speedLight', name: 'Speed Light' },
			],
			statusFilters: [
				{ key: 'ready', name: 'Ready' },
				{ key: 'busy', name: 'Busy' },
			],
			typesActiveFilter: [],
			statusActiveFilter: '',
			projectActiveFilter: [],
			branchIdsActiveFilter: [],
			workspaceActiveFilter: '',
			assignedToActiveFilter: [],
			descriptionActiveFilter: '',
			manufacturerIdActiveFilter: '',
			qrCodeActiveFilter: '',
			userPageLimit: 10000,
			userPage: 1,
			userHasNextPage: true,
			projectFilters: [],
			isBranchIdsFiltersLoading: true,
			isProjectsLoading: true,
			isVendorUsersLoading: true,
		};

		this.searchDropDownRef = React.createRef();
		this.wrapper = React.createRef();
	}
	componentDidMount = async () => {
		let searchURL = new URLSearchParams(window.location.search);
		let res1 = false;
		res1 = await this.getVendorsWorkspaces(getVendorInfo, {
			vendorId: this.props.params.vendorID,
		});
		if (res1 !== false) {
			let json = {};
			let urlSearch =
				_.size(window.location.search.split('?')) > 1
					? window.location.search.split('?')[1].split('&')
					: [];
			if (_.size(urlSearch) > 0) {
				let count = 0;
				let tempCount = 0;
				let searchType = null;
				let tempUrlSearch = _.cloneDeep(urlSearch);
				while (tempCount < _.size(tempUrlSearch)) {
					let subString = tempUrlSearch[tempCount].split('=');

					if (subString[0] && subString[0] === 'searchType') {
						searchType = subString[1];
					}
					tempCount++;
				}
				while (count < _.size(urlSearch)) {
					let subString = urlSearch[count].split('=');
					if (subString[0] && subString[0] !== 'searchType') {
						json = {
							filters: {
								...json.filters,
								[`${subString[0] === 'search' ? searchType : subString[0]}`]:
									subString[0] === 'page' || subString[0] === 'limit'
										? parseInt(subString[1])
										: subString[0] === 'tenantIds'
										? [subString[1]]
										: subString[0] === 'status'
										? subString[1]
										: subString[0] === 'search'
										? new URLSearchParams(urlSearch[count]).get('search')
										: subString[1].split(','),
							},
						};
						if (subString[0] === 'search') {
							this.setState({
								searchType,
							});
						}
						this.setState({
							[`${
								subString[0] === 'tenantIds'
									? 'workspace'
									: subString[0] === 'projectIds'
									? 'project'
									: subString[0] === 'search'
									? searchType
									: subString[0]
							}ActiveFilter`]:
								subString[0] === 'tenantIds' || subString[0] === 'status'
									? subString[1]
									: subString[0] === 'search'
									? new URLSearchParams(urlSearch[count]).get('search')
									: subString[1].split(','),
						});
					}
					count++;
				}
			} else {
				json = {
					filters: {
						limit: this.state.limit,
						page: this.state.currentViewPage,
					},
				};
			}

			if (searchURL.has('branchIds')) {
				json.branchIds = searchURL.get('branchIds').split(',');
			}

			this.getEquipmentList(getEquipmentList, json);
		}

		this.getBranchList2(getBranchList, 'branchIdsFilters');

		if (searchURL.has('tenantIds')) {
			let projectFilters = [];
			let res2 = false;

			let projectsJson = {
				filters: { limit: 10000, page: 1 },
				workspaceIds: [
					_.find(res1, {
						key: searchURL.get('tenantIds'),
					})?.name,
				],
			};

			res2 = await this.getProjects(getProjects, projectsJson);

			if (res2 !== false) {
				projectFilters = res2;
				this.setState({
					projectFilters,
					isProjectsLoading: false,
				});
			}
		}

		this.getTenantUsers(getVendorUsers);

		document.addEventListener('mousedown', this.handleClickOutside);
	};

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	handleClickOutside = (event) => {
		if (
			this.searchDropDownRef.current &&
			!this.searchDropDownRef.current.contains(event.target) &&
			this.wrapper.current &&
			!this.wrapper.current.contains(event.target)
		) {
			this.setState({
				showSearchDropDown: false,
			});
		}
	};

	toggleSearchDropDown = () => {
		this.setState({
			showSearchDropDown: !this.state.showSearchDropDown,
		});
	};

	toggleSearchType = (e, type) => {
		let tempActiveFilter = this.state[`${this.state.searchType}ActiveFilter`];
		this.setState(
			{
				[`${this.state.searchType}ActiveFilter`]: '',
				[`${type}ActiveFilter`]: tempActiveFilter,
				searchType: type,
				showSearchDropDown: false,
				isPageLoading: _.size(tempActiveFilter.trim()) > 0,
			},
			() => {
				if (_.size(this.state[`${this.state.searchType}ActiveFilter`].trim()) > 0) {
					this.setState({
						currentViewPage: 1,
					});
					this.fetchMoreEquipments();
				}
			},
		);
	};

	updateDateFilter = (e, type, key) => {
		let columns = this.state.columns;

		columns[1]['title'] = _.find(this.state.dateFilters, { key: key })['name'];

		this.setState(
			{
				columns,
				currentViewPage: 1,
				dateTypeActiveFilter: key,
			},
			() => this.fetchMoreEquipments(),
		);
	};

	handleActiveFilter = async (e, type, key) => {
		let array;

		if (type === 'workspace') {
			if (key === this.state.workspaceActiveFilter) {
				this.setState({
					projectFilters: [],
					projectActiveFilter: [],
				});
			} else {
				let projectFilters = [];
				let json = {
					filters: {
						page: 1,
						limit: 10000,
					},
					workspaceIds: _.find(this.state.workspacesFilters, {
						key: key,
					})?.name,
				};
				let res = await this.getProjects(getProjects, json);
				if (res !== false) {
					projectFilters = res;
				}

				this.setState({
					projectFilters,
					isProjectsLoading: false,
				});
			}
			array = key === this.state.workspaceActiveFilter ? '' : key;
		} else if (type === 'status') {
			array = key === this.state.statusActiveFilter ? '' : key;
		} else {
			array = [...this.state[`${type}ActiveFilter`]];

			if (array.includes(key) == false) {
				array.push(key);
			} else {
				const index = array.indexOf(key);
				if (index > -1) {
					array.splice(index, 1); // 2nd parameter means remove one item only
				}
			}
		}

		this.setState(
			{
				[`${type}ActiveFilter`]: array,
				currentViewPage: 1,
				isPageLoading: true,
			},
			() => {
				this.fetchMoreEquipments();
			},
		);
	};

	handleclearSelection = (e, type) => {
		if (type === 'workspace') {
			this.setState({
				projectFilters: [],
				projectActiveFilter: [],
			});
		}
		this.setState(
			{
				[`${type}ActiveFilter`]: type === 'workspace' ? '' : [],
				currentViewPage: 1,
				isPageLoading: true,
			},
			() => this.fetchMoreEquipments(),
		);
	};

	// goToEquipment = (vendorID, expenseID, projectID) => {
	// 	this.props.navigate(
	// 		`/huemn-payments/${vendorID}/project/${projectID}/payment/${expenseID}`
	// 	);
	// };

	fetchMoreEquipments = async () => {
		let queryString = `?page=${this.state.currentViewPage}&limit=${this.state.limit}`;

		//Condition for Equipment Type
		if (_.size(this.state.typesActiveFilter) > 0)
			queryString = `${queryString}&types=${this.state.typesActiveFilter.toString()}`;

		//Condition for Equipment Status
		if (_.size(this.state.statusActiveFilter) > 0)
			queryString = `${queryString}&status=${this.state.statusActiveFilter.toString()}`;

		//Condition for Assigned To
		if (_.size(this.state.assignedToActiveFilter) > 0)
			queryString = `${queryString}&assignedTo=${this.state.assignedToActiveFilter.toString()}`;

		//Condition for workspace
		if (_.size(this.state.workspaceActiveFilter) > 0)
			queryString = `${queryString}&tenantIds=${this.state.workspaceActiveFilter.toString()}`;

		//Condition for branchIds
		if (_.size(this.state.branchIdsActiveFilter) > 0)
			queryString = `${queryString}&branchIds=${this.state.branchIdsActiveFilter.toString()}`;

		//Condition for projects
		if (_.size(this.state.projectActiveFilter) > 0)
			queryString = `${queryString}&projectIds=${this.state.projectActiveFilter.toString()}`;

		//Condition for Search String
		if (_.size(this.state[`${this.state.searchType}ActiveFilter`].trim()) > 0)
			queryString = `${queryString}&search=${this.state[
				`${this.state.searchType}ActiveFilter`
			].trim()}&searchType=${this.state.searchType}`;

		this.props.navigate(`/${this.props.params.vendorID}/equipments${queryString}`);

		let json = {
			filters: {
				page: this.state.currentViewPage,
				limit: this.state.limit,
			},
		};
		let equipmentSummaryJson = {};

		//have to write conditions for date range.

		//Condition for Type
		if (_.size(this.state.typesActiveFilter) > 0)
			json = {
				filters: {
					...json.filters,
					types: this.state.typesActiveFilter,
				},
			};

		//Condition for Status
		if (_.size(this.state.statusActiveFilter) > 0)
			json = {
				filters: {
					...json.filters,
					status: this.state.statusActiveFilter,
				},
			};
		//Condition for Assigned To
		if (_.size(this.state.assignedToActiveFilter) > 0)
			json = {
				filters: {
					...json.filters,
					assignedTo: this.state.assignedToActiveFilter,
				},
			};
		//Condition for Workspace
		if (_.size(this.state.workspaceActiveFilter) > 0)
			json = {
				filters: {
					...json.filters,
					tenantIds: [this.state.workspaceActiveFilter],
				},
			};
		//Condition for branchIds
		if (_.size(this.state.branchIdsActiveFilter) > 0) {
			json = {
				filters: {
					...json.filters,
					branchIds: this.state.branchIdsActiveFilter,
				},
				branchIds: this.state.branchIdsActiveFilter,
			};
		}

		//Condition for Project
		if (_.size(this.state.projectActiveFilter) > 0)
			json = {
				...json,
				filters: {
					...json.filters,
					projectIds: this.state.projectActiveFilter,
				},
			};
		//condition for search
		if (_.size(this.state[`${this.state.searchType}ActiveFilter`].trim()) > 0) {
			json.filters[this.state.searchType] =
				this.state[`${this.state.searchType}ActiveFilter`].trim();
		}

		await this.getEquipmentList(
			_.size(this.state.branchIdsActiveFilter) > 0 ? getEquipmentList : getOnlyEquipmentList,
			json,
		);
	};

	onClickNextPage = async () => {
		if (this.state.currentViewPage < this.state.totalPages) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage + 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreEquipments();
				},
			);
		}
	};
	applyFilter = async (filter, type) => {
		if (type === 'workspace') {
			if (_.size(filter.trim()) === 0) {
				this.setState({
					projectActiveFilter: [],
				});
				let projectFilters = [];
				let json = {
					filters: {
						page: 1,
						limit: 10000,
					},
				};
				let res = await this.getProjects(getProjects, json);
				if (res !== false) {
					projectFilters = res;
				}

				this.setState({
					projectFilters,
					isProjectsLoading: false,
				});
			} else {
				let projectFilters = [];
				let json = {
					filters: {
						page: 1,
						limit: 10000,
					},
					workspaceIds: _.find(this.state.workspacesFilters, {
						key: filter.trim(),
					})?.name,
				};
				let res = await this.getProjects(getProjects, json);
				if (res !== false) {
					projectFilters = res;
				}

				this.setState({
					projectFilters,
					isProjectsLoading: false,
				});
			}
		}

		this.setState(
			{
				[`${type}ActiveFilter`]: filter,
				currentViewPage: 1,
				equipmentList: {},
				isPageLoading: true,
			},
			() => {
				this.fetchMoreEquipments();
			},
		);
	};
	handleGoToPage = async (e) => {
		this.setState(
			{
				currentViewPage: e,
				isPageLoading: true,
			},
			async () => {
				await this.fetchMoreEquipments();
			},
		);
	};
	onClickPreviousPage = async () => {
		if (this.state.currentViewPage > 1) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage - 1,
					isPageLoading: true,
				},
				async () => {
					await this.fetchMoreEquipments();
				},
			);
		}
	};

	searchString = (e) => {
		this.setState({
			[`${this.state.searchType}ActiveFilter`]: e.target.value,
			isPageLoading: true,
			currentViewPage: 1,
		});

		if (this.timeout) clearTimeout(this.timeout);
		this.timeout = setTimeout(async () => {
			this.fetchMoreEquipments();
		}, 1000);
	};

	render() {
		return (
			<div className="layout-wrapper">
				{this.state.isLoading ? (
					<div className="container">
						<LoadingBar />
					</div>
				) : (
					<div className="container">
						{/* {this.state.totalApprovalsPending === 0 ? (
							''
						) : (
							<div
								className="topbar"
								style={{
									display: 'flex',
									alignItems: 'center',
									background: '#121212',
								}}
							>
								<PendingIcon /> {this.state.totalApprovalsPending}{' '}
							<label style={{ fontSize: 16, marginRight: 5 }}>
								{this.state.totalVerificationsPending}
							</label>{' '}
							12 Equipments are currently in busy state
							</div>
						)} */}
						<div className="searchContainer">
							<a className="title">Equipments</a>
							<div className="searchWrapper">
								<div className="search-inner-left">
									<span className="search-icon">
										<SearchIcon />
									</span>
									<input
										placeholder="Search"
										name={this.state.searchType}
										value={this.state[`${this.state.searchType}ActiveFilter`]}
										onChange={(e) => this.searchString(e)}
									/>
								</div>
								<div className="search-inner-right">
									<span className="in-text">in</span>
									<span
										className="search-dropdown-btn"
										style={{ position: 'relative' }}
									>
										<a
											className="search-type"
											onClick={(e) => this.toggleSearchDropDown(e)}
											ref={this.wrapper}
										>
											{this.state.searchType === 'qrCode'
												? 'QR Code'
												: this.state.searchType === 'manufacturerId'
												? 'Serial number'
												: this.state.searchType === 'description'
												? 'Description'
												: ''}
											<b
												className={
													this.state.showSearchDropDown ? 'invert' : ''
												}
											>
												<DownIcon />
											</b>
										</a>
										{this.state.showSearchDropDown ? (
											<div
												className="search-dropdown right-zero search-type"
												ref={this.searchDropDownRef}
											>
												<a
													className={`item ${
														this.state.searchType === 'qrCode'
															? 'active'
															: ''
													}`}
													onClick={(e) =>
														this.toggleSearchType(e, 'qrCode')
													}
												>
													QR Code
												</a>
												<a
													className={`item ${
														this.state.searchType === 'manufacturerId'
															? 'active'
															: ''
													}`}
													onClick={(e) =>
														this.toggleSearchType(e, 'manufacturerId')
													}
												>
													Serial number
												</a>
												<a
													className={`item ${
														this.state.searchType === 'description'
															? 'active'
															: ''
													}`}
													onClick={(e) =>
														this.toggleSearchType(e, 'description')
													}
												>
													Description
												</a>
											</div>
										) : (
											''
										)}
									</span>
								</div>
							</div>
						</div>

						<div className="filters">
							<Filter
								type={'types'}
								label={'Category'}
								version="v2"
								applyFilter={this.applyFilter}
								filters={this.state.typesFilters}
								activeFilter={this.state.typesActiveFilter}
								handleActiveFilter={(e, type, key) =>
									this.handleActiveFilter(e, 'types', key)
								}
								clearSelection={(e) => this.handleclearSelection(e, 'types')}
								isMultipleSelectable={true}
							/>
							<Filter
								type={'workspace'}
								label={'Workspaces'}
								filters={this.state.workspacesFilters}
								activeFilter={this.state.workspaceActiveFilter}
								handleActiveFilter={(e, status, key) =>
									this.handleActiveFilter(e, 'workspace', key)
								}
								clearSelection={(e) => this.handleclearSelection(e, 'workspace')}
								isMultipleSelectable={false}
								version="v2"
								applyFilter={this.applyFilter}
							/>
							<Filter
								type={'status'}
								label={'Status'}
								filters={this.state.statusFilters}
								activeFilter={this.state.statusActiveFilter}
								handleActiveFilter={(e, status, key) =>
									this.handleActiveFilter(e, 'status', key)
								}
								clearSelection={(e) => this.handleclearSelection(e, 'status')}
								isMultipleSelectable={false}
								version="v2"
								applyFilter={this.applyFilter}
							/>
							{this.state.isVendorUsersLoading === true ? null : (
								<Filter
									type={'assignedTo'}
									label={'AssignedTo'}
									filters={this.state.assignedToFilters}
									activeFilter={this.state.assignedToActiveFilter}
									handleActiveFilter={(e, type, key) =>
										this.handleActiveFilter(e, 'assignedTo', key)
									}
									clearSelection={(e) =>
										this.handleclearSelection(e, 'assignedTo')
									}
									isMultipleSelectable={true}
									version="v2"
									applyFilter={this.applyFilter}
								/>
							)}
							{this.state.isBranchIdsFiltersLoading === true ? null : (
								<Filter
									type={'branchIds'}
									label={'Branch Id'}
									filters={this.state.branchIdsFilters}
									activeFilter={this.state.branchIdsActiveFilter}
									handleActiveFilter={(e, type, key) =>
										this.handleActiveFilter(e, 'branchIds', key)
									}
									clearSelection={(e) =>
										this.handleclearSelection(e, 'branchIds')
									}
									isMultipleSelectable={true}
									version="v2"
									applyFilter={this.applyFilter}
								/>
							)}
							{this.state.workspaceActiveFilter === '' ||
							this.state.isProjectsLoading === true ? null : (
								<Filter
									type={'project'}
									label={'Project'}
									filters={this.state.projectFilters}
									activeFilter={this.state.projectActiveFilter}
									handleActiveFilter={(e, status, key) =>
										this.handleActiveFilter(e, 'project', key)
									}
									clearSelection={(e) => this.handleclearSelection(e, 'project')}
									isMultipleSelectable={true}
									version="v2"
									applyFilter={this.applyFilter}
								/>
							)}
						</div>
						<div className={'table'}>
							<div
								style={{
									display: 'flex',
									gap: '15px',
								}}
							>
								<EquipmentsSummary data={this.state.equipmentSummary} />
								<DataTableCompact
									tableHeaderLeftPad={35}
									isLoading={this.state.isLoading}
									tableHeader={`${this.state.mainFilter} PROJECTS`}
									columns={this.state.columns}
									activeSortType={this.state.sortType}
									activeSortBy={this.state.sortBy}
									//handleSort={this.handleProjectSort}
									isPageLoading={this.state.isPageLoading}
									limit={this.state.limit}
									totalPages={this.state.totalPages}
									currentViewPage={this.state.currentViewPage}
									lengthOfList={this.state.lengthOfList}
									onClickNextPage={this.onClickNextPage}
									onClickPreviousPage={this.onClickPreviousPage}
									dataList={this.state.equipmentList}
									goToPage={(e) => this.handleGoToPage(e)}
									module={'project'}
									searchQuery={''}
									mainFilter={''}
								>
									{_.map(this.state.equipmentList, (equipment, index) => {
										// let workspaceDetails = _.find(
										// 	this.state.workspaceList,
										// 	{
										// 		_id: equipment.tenantId,
										// 	}
										// );
										return (
											<EquipmentListTableRow
												handleRowClick={() => {}}
												dateTypeActiveFilter={
													this.state.dateTypeActiveFilter
												}
												workspacesFilters={this.state.workspacesFilters}
												key={equipment.id}
												data={{
													...equipment,
													//workspaceDetails,
												}}
												{...this.props}
												//updateFlagged={this.updateFlagged}
												// handleRowClick={(e) =>
												// 	this.goToExpenses(
												// 		workspaceDetails.vendorID,
												// 		expense.id,
												// 		expense.projectId
												// 	)
												// }
												typeList={this.state.typeFilters}
											/>
										);
									})}
								</DataTableCompact>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default withRouter(Expenses);
